import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';
import React from 'react';
import UDPagination from 'ud-ui/components/pagination';
import { TourneyEncoded } from '../../../domain/interfaces/tourney-encoded';
import MainComponentsTourneysList from '../tourneys-list';

type TourneysBodyProps = {
  filters: any;
  tourneys: Championship[];
  pages: number;
  onDetail: (id: TourneyEncoded['id']) => any;
  onPageChange: (page: number) => any;
};

export const TournamentsBody = (props: TourneysBodyProps) => {
  const { filters, tourneys, pages, onDetail, onPageChange } = props;

  return (
    <>
      <MainComponentsTourneysList tourneys={tourneys} onDetail={onDetail} />
      <UDPagination className="my-8 justify-start px-6" pages={pages} currentPage={filters.page} onPageChange={onPageChange} />
    </>
  );
};
